import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsCmConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static BURIAL_TYPE_LABEL = "Burial type";
    static BURIAL_DATE_LABEL = "Burial date";
    static FUNERAL_PARLOUR_LABEL = "Funeral Parlour";
    static CEMETERY_LABEL = "Which cemetery / graveyard are you applying to?";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static BURIAL_TYPE_FORM_CONTROL_NAME = "burialType";
    static BURIAL_DATE_FORM_CONTROL_NAME = "burialDate";
    static FUNERAL_PARLOUR_FORM_CONTROL_NAME = "funeralParlour";
    static CEMETERY_FORM_CONTROL_NAME = "cemeteryId";
    static DEFAULT_CEMETERY_NAME = "Any";
    static MISSING_FUNERAL_PARLOUR_METADATA = "Funeral parlour metadata is missing.";
    static EDITABLE_RECIPIENT_FIELDS = [
        "name",
        "surname",
        "homePhone",
        "telephone",
        "cellphone",
        "email",
        "organisation",
        "designation",
        "professionalBody",
        "professionalBodyRegNum",
        "streetAddress",
        "streetSuburb",
        "streetCity",
        "streetProvince",
        "streetCode",
        "postalAddress",
        "postalSuburb",
        "postalCity",
        "postalProvince",
        "postalCode",
    ];
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        burialDate: {
            required: `Burial date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        burialType: {
            required: `Burial type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
